import type { SplashMode } from '@/models/ar-splash-mode'
import type { SplashBrand } from '@/services/fetch-wheel-brand'

/** What the splash shows: the mode (null until the boot probe answers) and
 *  the wheel's brand (null until the parts API answers, or never). */
export interface SplashState {
  readonly mode: SplashMode | null
  readonly brand: SplashBrand | null
}

export interface SplashStore {
  getState(): SplashState
  subscribe(listener: () => void): () => void
  setMode(mode: SplashMode): void
  setBrand(brand: SplashBrand | null): void
}

export function createSplashStore(initial: SplashState = { mode: null, brand: null }): SplashStore {
  let state = initial
  const listeners = new Set<() => void>()
  const update = (next: Partial<SplashState>) => {
    state = { ...state, ...next }
    for (const listener of Array.from(listeners)) listener()
  }
  return {
    getState: () => state,
    subscribe(listener) {
      listeners.add(listener)
      return () => {
        listeners.delete(listener)
      }
    },
    setMode: (mode) => update({ mode }),
    setBrand: (brand) => update({ brand }),
  }
}
